import { render, staticRenderFns } from "./sizeController.vue?vue&type=template&id=6538ce27&"
import script from "./sizeController.vue?vue&type=script&lang=ts&"
export * from "./sizeController.vue?vue&type=script&lang=ts&"
import style0 from "./sizeController.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports